var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg52Cb4Ab48Cd21C8925Faa65471C7Faf3A5F4B64D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 1755 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 3",
    filter: "url(#filter0_f_2002_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 52.5H1702.5",
    stroke: "url(#paint0_linear_2002_48)",
    strokeWidth: 17,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M52.5 52.5H1702.5",
    stroke: "url(#paint1_linear_2002_48)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2002_48",
    x: 0,
    y: 0,
    width: 1755,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur_2002_48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_48",
    x1: 52.5,
    y1: 53,
    x2: 1702.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2002_48",
    x1: 52.5,
    y1: 53,
    x2: 1702.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg52Cb4Ab48Cd21C8925Faa65471C7Faf3A5F4B64D);
export default __webpack_public_path__ + "static/media/52cb4ab48cd21c8925faa65471c7faf3a5f4b64d.39e611b5e5d98213a845067106f51037.svg";
export { ForwardRef as ReactComponent };